import { useAuth0 } from '@auth0/auth0-react';
import React, { Fragment, ReactElement, useEffect, useState } from 'react';


import { FormInput, FormSelect } from 'src/components/Form';
import { Spinner } from 'src/components/Spinner';
import { ILoadState, IArenaPart, IArenaRevision } from 'src/types';
import { getArenaPart, getArenaPartRevisions } from 'src/util/Arena';


interface IPartDisplayProps {
  partNumber: string;
  partFilter: 'TLA' | 'Component';
  onChange: (part: IArenaPart, revsion: IArenaRevision) => void;
}

export const PartInput = ({ partNumber, partFilter, onChange }: IPartDisplayProps) => {
  const  {isLoading, isAuthenticated, getAccessTokenSilently } = useAuth0();

  type IPartFormData = { part: string, revision: string } & { [key: string]: string };
  type partFieldNames = keyof IPartFormData;

  const [displayState, setDisplayState] = useState<ILoadState>(ILoadState.NEW);
  const [arenaPart, setArenaPart] = useState<IArenaPart>();
  const [formData, setFormData] = useState<IPartFormData>({ part: partNumber, revision: '' })
  const [validation, setValidation] = useState<partFieldNames[]>([]);
  const [revisions, setRevisions] = useState<IArenaRevision[]>([]);
  const [partError, setPartError] = useState('');

  const formChange = (item: React.ReactText, event: React.FormEvent<HTMLInputElement | HTMLSelectElement>) => {
    const newFormData = { ...formData };
    if (item == 'part') {
      newFormData.part = event.currentTarget.value.toUpperCase();
      newFormData.revision = '';
      setDisplayState(ILoadState.NEW);
      setValidation([]);
    } else {
      newFormData[item] = event.currentTarget.value;
      if (item == 'revision') {
        const revision = revisions.find(r => r.guid == event.currentTarget.value);
        if (revision && arenaPart) {
          onChange(arenaPart, revision)
        }
      }
    }
    setFormData(newFormData);
  }

  const onPartBlur = (event: React.FocusEvent) => {
    console.log('Blurring');

    const partNo = formData.part;
    /*
    if (!partNo.match(/^S00(\d\d\d\d)|(-\d{3}-\d{5})$/)) {
      if (!validation.includes('part')) {
        const newValidation = [...validation];
        newValidation.push('part');
        setValidation(newValidation);
      }
      return;
    }
      */
    console.log('getting part');
    setDisplayState(ILoadState.LOADING);
    getAccessTokenSilently().then(accessToken => {

    getArenaPart(accessToken, partNo)
      .then((part) => {
        console.log('got Part: ' + JSON.stringify(part));
        /*
        const isTLA = [
          'TLA Rack Assembly - ORV1',
          'TLA Rack Assembly - ORV2',
          'Discovery Assembly'
        ].includes(part.category.name);
        */
        const isTLA = (part.category.name == "Customer Rack Parts");
        if (partFilter == 'TLA' && !isTLA || partFilter != 'TLA' && isTLA) {
          setDisplayState(ILoadState.ERROR);
          setPartError(partFilter == 'TLA' ? 'Part is not a rack' : 'Part is not a component');
          const newValidation = [...validation];
          newValidation.push('part');
          setValidation(newValidation);
        } else {
          setArenaPart(part);
          setValidation(validation.filter(v => v != 'part'));
          getArenaPartRevisions(accessToken, part.number)
         .then(revisions => {
              console.log('Got revisions');
              setRevisions(revisions);
              if (revisions.length > 0) {
                const newFormData = formData;
                newFormData.revision = revisions[0].guid;
                setFormData(newFormData);
                onChange(part, revisions[0]);
                setDisplayState(ILoadState.READY);
              } else {
                setDisplayState(ILoadState.ERROR);
                setPartError('No revisions for part');
              }
            })
            .catch(err => {
              setDisplayState(ILoadState.ERROR);
              setPartError('Failed to get revisions');
              console.log('Failed to get revisions: ' + err.message);
            });
        }
      })
      .catch((err) => {
        console.log('Failed to get part: ' + err.message);
        setDisplayState(ILoadState.ERROR);
        setPartError('Failed to get part');
      })
    });
  }


  if (isLoading) {
    return <Spinner />
  }

  const revItem = revisions.find(r => r.guid == formData.revision);
  const revNumber = revItem ? revItem.number : '';
  return <div>
    <FormInput
      label="BOM Part Number"
      name="part"
      changeFn={formChange}
      blurFn={onPartBlur}
      data={formData}
      validation={validation}
    />
    {blankOrInvalidPart(displayState, validation.includes('part'), formData.part)}
    {displayState == ILoadState.LOADING ? <Spinner /> : <></>}
    {displayState == ILoadState.READY ? <>
      <FormSelect
        label="Revision"
        name="revision"
        changeFn={formChange}
        data={formData}
        displayFn={() => revisions.map(r => { return { value: r.guid, key: r.guid, text: r.number + (r.effective ? ' (current)' : '') } })}
        validation={validation}
      /><div>
        {arenaPart!.number} Rev {revNumber}
        <br />{arenaPart!.name}
      </div></> : <></>}
    {displayState == ILoadState.ERROR ? <div>{partError}</div> : <></>}
  </div>

}

const blankOrInvalidPart = (displayState: ILoadState, partError: boolean, partNo: string) => {
  if (displayState != ILoadState.NEW) {
    return <React.Fragment />
  }
  if (partError && partNo.trim() != '') {
    return <div>Invalid Part Number</div>
  }
  return <React.Fragment />
}
